import { render, staticRenderFns } from "./myFavorites.vue?vue&type=template&id=1bcf1ffe&scoped=true&"
import script from "./myFavorites.vue?vue&type=script&lang=js&"
export * from "./myFavorites.vue?vue&type=script&lang=js&"
import style0 from "./myFavorites.vue?vue&type=style&index=0&id=1bcf1ffe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf1ffe",
  null
  
)

export default component.exports